// ESSENYA lightweight first-party analytics client.
// Sends batched events to /api/analytics/collect. No third-party, no fingerprinting.
const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/analytics/collect`;
const VID_KEY = 'essenya_vid';
const SID_KEY = 'essenya_sid';
const SID_TS_KEY = 'essenya_sid_ts';
const SESSION_MAX_MS = 30 * 60 * 1000;

const uuid = () => (crypto.randomUUID ? crypto.randomUUID()
  : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0; return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    }));

function getVisitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) { v = uuid(); localStorage.setItem(VID_KEY, v); }
  return v;
}

// Returns { sessionId, isNew }
function getSession() {
  const now = Date.now();
  const ts = parseInt(sessionStorage.getItem(SID_TS_KEY) || '0', 10);
  let sid = sessionStorage.getItem(SID_KEY);
  let isNew = false;
  if (!sid || !ts || now - ts > SESSION_MAX_MS) {
    sid = uuid();
    isNew = true;
    sessionStorage.setItem(SID_KEY, sid);
  }
  sessionStorage.setItem(SID_TS_KEY, String(now));
  return { sessionId: sid, isNew };
}

function deviceType() {
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
}

function utmParams() {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get('utm_source') || undefined,
    utm_medium: p.get('utm_medium') || undefined,
    utm_campaign: p.get('utm_campaign') || undefined,
  };
}

let queue = [];
let timer = null;

function flush() {
  if (!queue.length) return;
  const payload = JSON.stringify({ events: queue });
  queue = [];
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true });
    }
  } catch { /* swallow */ }
}

function scheduleFlush() {
  if (timer) return;
  timer = setTimeout(() => { timer = null; flush(); }, 2500);
}

export function track(eventName, props = {}) {
  try {
    const { sessionId } = getSession();
    queue.push({
      event_id: uuid(),
      event_name: eventName,
      occurred_at: new Date().toISOString(),
      visitor_id: getVisitorId(),
      session_id: sessionId,
      page_path: window.location.pathname,
      page_url: window.location.href,
      referrer: document.referrer || undefined,
      device_type: deviceType(),
      ...utmParams(),
      ...props,
    });
    if (queue.length >= 10) flush(); else scheduleFlush();
  } catch { /* swallow */ }
}

export function trackPageView() {
  const { isNew } = getSession();
  if (isNew) track('session_start');
  track('page_view');
}

if (typeof window !== 'undefined') {
  window.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);
}
